/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function NumberCircleSix(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M148,144a20,20,0,1,1-20-20A20.02229,20.02229,0,0,1,148,144Zm84-16A104,104,0,1,1,128,24,104.11791,104.11791,0,0,1,232,128Zm-68,16a36.04061,36.04061,0,0,0-36-36q-.917,0-1.82324.04639l16.6914-27.94385a8.00015,8.00015,0,0,0-13.73632-8.20508l-32.249,53.98926c-.11157.18652-.20776.37793-.30224.56982A35.99384,35.99384,0,1,0,164,144Z" />
    </Svg>
  );
}

export default NumberCircleSix;
